import script from "./PasswordResetView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordResetView.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordResetView.vue?vue&type=style&index=0&id=f613e746&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f613e746"]])

export default __exports__